import React, { PureComponent } from "react";
import _ from "i18n";
import { PERIODS_UNITS } from "Config";
import { TiArrowSortedDown } from "react-icons/ti";
import { SingleDatePicker } from "react-dates";

import styles from "./CollaboratorClientsFolders.local.scss";
import {
  ChartActive,
  ChartDesactive,
  TabActive,
  TabDesactive
} from "../Common/Icons";
import { Tooltip } from "antd";

class CollaboratorClientsFoldersFilter extends PureComponent {
  //******************   Content Functions  **************//

  intervalID;

  constructor(props) {
    super(props);

    this.state = {
      loading: false
    };
  }

  componentWillUnmount() {
    clearTimeout(this.intervalID);
  }

  componentDidMount() {
    document.addEventListener(
      "mousedown",
      this.handleClickOutsidePeriodFilter.bind(this)
    );
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideYearSelect.bind(this)
    );
  }

  setPeriodWrapperRef(node) {
    this.periodWrapperRef = node;
  }
  setYearWrapperRef(node) {
    this.yearWrapperRef = node;
  }

  handleClickOutsidePeriodFilter(event) {
    if (
      this.periodWrapperRef &&
      !this.periodWrapperRef.contains(event.target)
    ) {
      this.setState({ periodsFilterIsVisible: false });
    }
  }
  handleClickOutsideYearSelect(event) {
    if (this.yearWrapperRef && !this.yearWrapperRef.contains(event.target)) {
      this.setState({ yearsSelectIsVisible: false });
    }
  }

  handleDisplayPeriodFilter = () => {
    this.setState(state => {
      return {
        periodsFilterIsVisible: !state.periodsFilterIsVisible
      };
    });
  };
  handleDisplayYearSelectItems = () => {
    this.setState(state => {
      return {
        yearsSelectIsVisible: !state.yearsSelectIsVisible
      };
    });
  };

  renderTabFilter = () => {
    return (
      <div className={styles.filter_dossier}>
        {PERIODS_UNITS.map(
          item =>
            item.value !== "MONTHLY" ? (
              <span
                key={`period-${item.value}`}
                className={
                  this.props.period === item.value
                    ? styles.active_vue
                    : styles.inactive_vue
                }
                onClick={
                  this.props.period !== item.value
                    ? () => this.handleActivateTab(item.value)
                    : null
                }
              >
                {item.label}
              </span>
            ) : (
              ""
            )
        )}
      </div>
    );
  };

  renderDataTypeFilter = () => {
    return (
      <div className={styles.filter_dossier}>
        {this.props.tableIsVisible ? (
          <span className={styles.active_vue}>
            <TabActive />
            {_("tableView")}
          </span>
        ) : (
          <Tooltip placement="bottom" title={_("Visualiser")}>
            <span
              onClick={() => this.props.handleActivateTable()}
              className={styles.inactive_vue}
            >
              <TabDesactive />
              {_("tableView")}
            </span>
          </Tooltip>
        )}
        {this.props.graphIsVisible ? (
          <span className={styles.active_vue}>
            <ChartActive />
            {_("graphicView")}
          </span>
        ) : (
          <Tooltip placement="bottom" title={_("Visualiser")}>
            <span
              onClick={() => this.props.handleActivateChart()}
              className={styles.inactive_vue}
            >
              <ChartDesactive />
              {_("graphicView")}
            </span>
          </Tooltip>
        )}
      </div>
    );
  };

  renderSelectPeriodFilter = () => {
    let { periodsFilterIsVisible, yearsSelectIsVisible } = this.state;

    return (
      <div className={styles.mg_330}>
        <div
          ref={this.setPeriodWrapperRef.bind(this)}
          className={
            styles.customed_select +
            " " +
            (periodsFilterIsVisible ? styles.customed_select_opened : "")
          }
          style={{ width: 270 }}
        >
          <div className={styles.customed_select_header}>
            <span>
              {_("fromDate")} 01 {_("janvier")} {_("to")}{" "}
              {this.props.date.format("DD MMM YYYY")}
            </span>
            <div className={styles.actions}>
              <div>
                <span
                  className={styles.action}
                  onClick={this.handleDisplayPeriodFilter}
                >
                  <TiArrowSortedDown />
                </span>
              </div>
            </div>
          </div>
          {periodsFilterIsVisible && (
            <div className={styles.customed_select_body}>
              <div className={styles.customed_select_body_options}>
                <div
                  id="single-date-calendar"
                  className={styles.filter_frame_field}
                >
                  <SingleDatePicker
                    id="your_unique_id"
                    isOutsideRange={day => day.isAfter(this.props.lastDate)}
                    date={this.props.date}
                    displayFormat={() => "DD/MM/YYYY"}
                    onDateChange={this.handleChangeFilterDate}
                    focused={periodsFilterIsVisible}
                    onFocusChange={({ focused }) => this.setState({ focused })}
                    numberOfMonths={1}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        <div
          ref={this.setYearWrapperRef.bind(this)}
          className={
            styles.customed_select +
            " " +
            (yearsSelectIsVisible ? styles.customed_select_opened : "")
          }
          style={{ width: 90, marginLeft: 5 }}
        >
          <div className={styles.customed_select_header}>
            <span>{this.props.year}</span>
            <div className={styles.actions}>
              <div>
                <span
                  className={styles.action}
                  onClick={this.handleDisplayYearSelectItems}
                >
                  <TiArrowSortedDown />
                </span>
              </div>
            </div>
          </div>
          {yearsSelectIsVisible && (
            <div className={styles.customed_select_body}>
              <div className={styles.customed_select_body_options}>
                {["2019", "2020", "2021"].map((item, index) => (
                  <div
                    key={index}
                    className={styles.customed_select_body_option}
                    onClick={() => this.handleSelectYear(item)}
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  handleActivateTab = period => {
    this.props.onChangeFilter(period, null, null);
  };

  handleChangeFilterDate = date => {
    this.props.onChangeFilter(null, date, null);
    this.setState({ periodsFilterIsVisible: false });
  };

  handleSelectYear = year => {
    this.props.onChangeFilter(null, null, year);
    this.setState({ yearsSelectIsVisible: false });
  };

  render() {
    return (
      <div className={styles.filter_block}>
        <div>{this.renderTabFilter()}</div>
        <div>{this.renderDataTypeFilter()}</div>
        <div>{this.renderSelectPeriodFilter()}</div>
      </div>
    );
  }
}

export default CollaboratorClientsFoldersFilter;



// WEBPACK FOOTER //
// ./src/components/CollaboratorClientsFolders/CollaboratorClientsFoldersFilter.js